import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MenuItem } from '@newgenus/common';

/**
 * Phone-native primary navigation: a fixed bottom tab bar rendered from the
 * same {@link MenuItem} list the desktop drawer uses. Shown only below the
 * handset breakpoint (the host gates it on `BreakpointService.isHandset$`).
 * Purely presentational — it emits the tapped item and lets the host route.
 */
@Component({
    selector: 'newgenus-mobile-bottom-nav',
    imports: [CommonModule, MatIconModule, MatBadgeModule],
    templateUrl: './mobile-bottom-nav.component.html',
    styleUrls: ['./mobile-bottom-nav.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileBottomNavComponent {
    @Input() items: MenuItem[] = [];
    @Input() selectedId: string | null = null;
    @Output() itemSelected = new EventEmitter<MenuItem>();

    public trackById(_index: number, item: MenuItem): string {
        return item.id;
    }
}
